import React from 'react';
import * as PropTypes from 'prop-types';
import NavBar from './NavBar';
import Icon from '../Icon';


export default class NavBarDefault extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func
  };

  static defaultProps = {
    title: document.title
  };

  shouldComponentUpdate(nextProps) {
    const { title } = this.props;
    return title !== nextProps.title;
  }

  render() {
    const { title, onClick } = this.props;

    return (
      <NavBar
        className="component-nav-bar-default"
        left={(<BackBtn onClick={onClick} />)}
        center={<Title title={title} />}
      />
    );
  }
}


Title.propTypes = {
  title: NavBarDefault.propTypes.title
};

Title.defaultProps = {
  title: NavBarDefault.defaultProps.title
};

function Title(props) {
  const { title } = props;

  return (
    <h1 className="component-nav-bar-default-title">{title}</h1>
  );
}

BackBtn.propTypes = {
  onClick: PropTypes.func
};

function BackBtn(props) {
  const { onClick } = props;
  return (
    <div
      role="button"
      className="component-nav-bar-default-back-btn"
      onClick={(event) => {
        if (onClick) {
          onClick(event);
        } else if (window.history.length > 1) {
          window.history.go(-1);
        } else {
          window.location.href = '/';
        }
      }}
    >
      <Icon name="back" />
    </div>
  );
}
